/* unplugin-vue-components disabled */import { render } from "./ChangeControl.vue?vue&type=template&id=52905e75"
import script from "./ChangeControl.vue?vue&type=script&lang=js"
export * from "./ChangeControl.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__